class OrderRequest {
    /**
     * The OrderRequest represents the data used to create an order.
     * It is used when storing the data for offline orders.
     *
     * Note that these two properties are the data for the order and reservation,
     * not the Order and Reservation objects themselves.
     *
     * @param {OrderConfirmationStructure} orderConfirmationStructure
     * @param {PaymentForApiStructure[]} payments
     * @param {ReservationStructure} reservationStructure
     */
    constructor(
        orderConfirmationStructure,
        payments,
        reservationStructure
    ) {
        /**
         * @type {OrderConfirmationStructure}
         */
        this.order = orderConfirmationStructure;

        /**
         * @type {PaymentForApiStructure[]}
         */
        this.payments = payments;

        /**
         * @type {ReservationStructure}
         */
        this.reservation = reservationStructure;
    }
}

module.exports = OrderRequest;
